module.exports = __webpack_public_path__ + "img/logo_text.7cd929f1.png";